// Textes de l'ErrorBoundary global (anciennement un dictionnaire local dans
// lib/ErrorBoundary.jsx — consolidé ici lors du passage EN-défaut).
export default {
  fr: {
    "errorBoundary.title": "Une erreur est survenue",
    "errorBoundary.body": "Quelque chose s'est mal passé lors du chargement de cette page. Veuillez réessayer.",
    "errorBoundary.reload": "Recharger la page",
  },
  en: {
    "errorBoundary.title": "Something went wrong",
    "errorBoundary.body": "Something went wrong while loading this page. Please try again.",
    "errorBoundary.reload": "Reload page",
  },
  es: {
    "errorBoundary.title": "Se produjo un error",
    "errorBoundary.body": "Algo salió mal al cargar esta página. Por favor, inténtalo de nuevo.",
    "errorBoundary.reload": "Recargar la página",
  },
};
